import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import { theme } from '../lib/theme';

export const useTheme = () => {
  const { theme: themeMode, toggleTheme, setThemeMode } = useContext(ThemeContext);
  const isDark = themeMode === 'dark';

  return {
    theme: theme,
    isDark,
    toggleTheme,
    setThemeMode
  };
}; 